import { QueryKey, useQueryClient } from "@tanstack/react-query";

export const useInavalidate = (queryKey: QueryKey) => {
  const queryClient = useQueryClient();
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey,
    });
  };

  return invalidate;
};
